// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6V11C17 13.7614 14.7614 16 12 16C9.23858 16 7 13.7614 7 11V6ZM6 10V11C6 14.3137 8.68629 17 12 17C15.3137 17 18 14.3137 18 11V10H20V11C20 15.0796 16.9463 18.446 13 18.9381V20H18V22H6V20H11V18.9381C7.05369 18.446 4 15.0796 4 11V10H6Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-microphone-1-filled')
export default class Microphone1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'microphone-1-filled',
    }
  }
}
